import { NumbersListSection } from './NumbersListSection/NumbersList.section';

export function NumbersPage() {
  return <NumbersListSection />;
}
